import { SET_SERVICE, SET_MODULE } from "./set"
import { BaseService, Service} from "./service"
async function bootstrap(app) {
	SET_SERVICE(app);
	SET_MODULE(app);
}
export {  bootstrap, BaseService, Service };